import React, { useState, useEffect } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import styles from './DateRangeSelector.module.css';
import { PRODUCT_TYPES } from '../../../constants/enums';
import { enGB } from "date-fns/locale";
import dateFunctions from '../../../utils/dateFunctions.js';

const DateRangeSelector = ({ onDateChange, defaultStart, defaultEnd, productType, classicPostings, country }) => {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [minDate, setMinDate] = useState(null);
    const [maxDate, setMaxDate] = useState(null);
    let format = dateFunctions.getCountrySpecificDateStringFormatFromCountry(country);

    const parseDate = (dateStr) => {
        if (!dateStr) return null;
        const date = new Date(dateStr);
        return new Date(date.getFullYear(), date.getMonth(), date.getDate());
    };

    const getFirstDayOfWeek = (date) => {
        const givenDate = new Date(date);
        const day = givenDate.getDay();
        const difference = day === 0 ? -6 : 1 - day;
        return new Date(givenDate.setDate(givenDate.getDate() + difference));
    };

    const getLastDayOfWeek = (date) => {
        const givenDate = new Date(date);
        const day = givenDate.getDay();
        const difference = day === 0 ? 0 : 7 - day;
        return new Date(givenDate.setDate(givenDate.getDate() + difference));
    };

    useEffect(() => {
        if (productType === PRODUCT_TYPES.PLAY || (!classicPostings || classicPostings.length == 0)) {
            setStartDate(parseDate(defaultStart));
            setEndDate(parseDate(defaultEnd));
            setMinDate(parseDate(defaultStart))
            setMaxDate(parseDate(defaultEnd))
        } else if (classicPostings) {
            console.log('c postings', classicPostings);
            console.log('default', defaultStart);
            setStartDate(getFirstDayOfWeek(parseDate(classicPostings[0].postingDate)));
            setEndDate(getLastDayOfWeek(parseDate(classicPostings[classicPostings.length - 1].postingDate)));
            setMinDate(getFirstDayOfWeek(parseDate(classicPostings[0].postingDate)));
            setMaxDate(getLastDayOfWeek(parseDate(classicPostings[classicPostings.length - 1].postingDate)));
        }
    }, [defaultStart, defaultEnd, classicPostings]);

    const handleStartDateChange = (date) => {
        let normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if (productType === PRODUCT_TYPES.CLASSIC) {
            normalizedDate = getFirstDayOfWeek(normalizedDate);
        }
        setStartDate(normalizedDate);
    };

    const handleEndDateChange = (date) => {
        let normalizedDate = new Date(date.getFullYear(), date.getMonth(), date.getDate());
        if (productType === PRODUCT_TYPES.CLASSIC) {
            normalizedDate = getLastDayOfWeek(normalizedDate);
        }
        setEndDate(normalizedDate);
    };

    const formatDateToYMD = (date) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const handleLoadDates = () => {
        if (productType === PRODUCT_TYPES.PLAY) {
            onDateChange(formatDateToYMD(startDate), formatDateToYMD(endDate));
        } else {
            onDateChange(startDate, endDate);
        }
    };

    const isMonday = (date) => {
        if (productType === PRODUCT_TYPES.PLAY) return true;
        const day = date.getDay();
        return day === 1;
    };

    const isSunday = (date) => {
        if (productType === PRODUCT_TYPES.PLAY) return true;
        const day = date.getDay();
        return day === 0;
    };

    return (
        <div>
            <h3>Filter by Period</h3>
            <div className={styles.container}>
                <div className={styles.row}>
                    <div className={styles.labelContainer}>
                        <label className={styles.label}>Start</label>
                        <DatePicker
                            locale={enGB}
                            filterDate={isMonday}
                            selected={startDate}
                            minDate={minDate}
                            maxDate={maxDate}
                            onChange={handleStartDateChange}
                            dateFormat={format}
                            className={styles.input}
                            placeholderText="Select Start Date"
                        />
                    </div>
                    <div className={styles.labelContainer}>
                        <label className={styles.label}>End</label>
                        <DatePicker
                            locale={enGB}
                            filterDate={isSunday}
                            minDate={minDate}
                            maxDate={maxDate}
                            selected={endDate}
                            onChange={handleEndDateChange}
                            dateFormat={format}
                            className={styles.input}
                            placeholderText="Select End Date"
                        />
                    </div>
                </div>
                <button className={styles.button} onClick={handleLoadDates}>Load selected</button>
            </div>
        </div>
    );
};

export default DateRangeSelector;
